<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_xvii"></a>
<p class="indentd">“She was spreading herself like the night over the<br/>universe and found no god to lie with.”</p>
<p class="rightf">Anaïs Nin</p>
<a id="page_xviii"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Front04.vue?6ee34070